import api from './api';

const getHolterByID = async payload => {
  const response = await api.get(`holter?id=${payload}`);
  return response.data;
};

export default getHolterByID;
